import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import './fancybox.d';
import { de } from '@fancyapps/ui/dist/fancybox/l10n/de.esm.js';
import { it } from '@fancyapps/ui/dist/fancybox/l10n/it.esm.js';
import { en } from '@fancyapps/ui/dist/fancybox/l10n/en.esm.js';

Fancybox.bind("[data-fancybox]", {
    l10n: { de, en, it }[document.documentElement.lang.split('-')[0]] || en,
});
